// src/pages/RecommendedJobs.js
import React from 'react';
import { Box, Chip, Typography, Card, Container, CardContent, CardActions, Button, Avatar, Grid } from '@mui/material';
import SidebarLeft from '../components/SidebarLeft';
import SidebarRight from '../components/SidebarRight';
import LeftSidebarRight from '../components/jobs/JobLeftSidebarCard';
import ChatList from '../components/ChatList';

const RecommendedJobs = () => {
    return (

        <Container maxWidth="lg" sx={{ marginTop: 4 }}>
            <Grid container spacing={2}>
                {/* 左侧菜单栏 */}
                <Grid item xs={12} md={3}>
                    <LeftSidebarRight />
                </Grid>

                {/* 主内容区 */}
                <Grid item xs={12} md={6}>
                    <Box sx={{ padding: '20px', "margin-bottom": "100px" }}>
                        {/* 职位搜索建议 */}
                        <Typography variant="h6" gutterBottom>职位搜索建议</Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <Chip label="remote" />
                            <Chip label="marketing manager" />
                            <Chip label="hr" />
                            <Chip label="legal" />
                            <Chip label="sales" />
                            <Chip label="amazon" />
                            <Chip label="google" />
                        </Box>

                        {/* 热门职位推荐 */}
                        <Box sx={{ marginTop: '40px' }}>
                            <Typography variant="h6" gutterBottom>热门职位推荐</Typography>
                            <Typography variant="subtitle1" gutterBottom>根据您的职业档案和搜索记录</Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="h6">后台无人售货</Typography>
                                            <Typography variant="body2">六喜珠宝公司</Typography>
                                            <Typography variant="body2">中国 北京市 北京市 (现场办公)</Typography>
                                            <Typography variant="body2">¥50/月 - ¥80/月</Typography>
                                            <Typography variant="body2">1 周前 · 0 位申请者</Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button size="small">申请</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="h6">初级运维值班员</Typography>
                                            <Typography variant="body2">文思海辉金融</Typography>
                                            <Typography variant="body2">中国 北京市 北京市 (现场办公)</Typography>
                                            <Typography variant="body2">4 天前 · 0 位申请者</Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button size="small">申请</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="h6">网络协议工程师3</Typography>
                                            <Typography variant="body2">中国人民解放军战略支援部队信息工程大学</Typography>
                                            <Typography variant="body2">中国 北京市 北京市 (现场办公)</Typography>
                                            <Typography variant="body2">5 天前 · 0 位申请者</Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button size="small">申请</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            </Grid>
                            <Button sx={{ marginTop: 2 }}>显示全部</Button>
                        </Box>

                        {/* 查看您申请哪些职位会胜人一筹 */}
                        <Box sx={{ marginTop: '40px' }}>
                            <Typography variant="h6" gutterBottom>看看您申请哪些职位会胜人一筹</Typography>
                            <Typography variant="subtitle1" gutterBottom>根据您收到回复的几率</Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="h6">Senior ASO | 资深ASO专员</Typography>
                                            <Typography variant="body2">Bitget</Typography>
                                            <Typography variant="body2">中国 (远程办公)</Typography>
                                            <Typography variant="body2">1 位校友在这里工作 · 5 小时前</Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button size="small">申请</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="h6">Sourcing Intern</Typography>
                                            <Typography variant="body2">爱立信</Typography>
                                            <Typography variant="body2">中国 北京市 北京市</Typography>
                                            <Typography variant="body2">111 位校友在这里工作 · 2 天前 · 3 位申请者</Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button size="small">申请</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            </Grid>
                            <Button sx={{ marginTop: 2 }}>显示全部</Button>
                        </Box>

                        {/* 更多职位推荐 */}
                        <Box sx={{ marginTop: '40px' }}>
                            <Typography variant="h6" gutterBottom>更多职位推荐</Typography>
                            <Typography variant="subtitle1" gutterBottom>根据您的职业档案和搜索记录</Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="h6">网络运维（数据中心）</Typography>
                                            <Typography variant="body2">北京先进数通信息技术股份公司</Typography>
                                            <Typography variant="body2">中国 北京市 北京市 (现场办公)</Typography>
                                            <Typography variant="body2">4 天前 · 0 位申请者</Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button size="small">申请</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>

                {/* 右侧栏 */}
                <Grid item xs={12} md={3}>
                    <SidebarRight />
                </Grid>
            </Grid>
        </Container>
    );
};

export default RecommendedJobs;